module.exports = __webpack_public_path__ + "static/Cel1PR-47c3368528bcc0934aaf486471ab3e11.mp4";